<template>
  <v-dialog
    v-model="internalValue"
    max-width="600px"
    persistent
  >
    <v-card class="pa-4">
      <!-- Header -->
      <v-card-title class="headline red--text text--darken-1">
        {{ $t('verification.errors_title') }}
      </v-card-title>

      <v-divider class="mb-3"></v-divider>

      <!-- Body -->
      <v-card-text>
        <div
          v-if="selectedItem && selectedItem.errors && selectedItem.errors.length"
          class="verification-list"
        >
          <div
            v-for="(err, idx) in selectedItem.errors"
            :key="idx"
            class="error-item"
          >
            <div class="error-field">
              <div class="field-name">
                <strong>{{ $t('verification.fields.' + err.field) }}</strong>
              </div>

              <div class="field-values">
                <div class="value original">
                  <span class="label">{{ $t('verification.original_value') }}:</span>
                  <span>{{ err.originalValue || '-' }}</span>
                </div>

                <div class="value corrected">
                  <span class="label">{{ $t('verification.correct_value') }}:</span>
                  <span>{{ err.correctValue || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="grey--text text--darken-1">
          {{ $t('verification.no_errors_found') }}
        </div>
      </v-card-text>

      <!-- Footer -->
      <v-divider class="my-2"></v-divider>

      <v-card-actions class="justify-end">
        <v-btn
          small
          outlined
          class="verify-btn close"
          @click="closeDialog"
        >
          {{ $t('close') }}
        </v-btn>

        <v-btn
          small
          outlined
          class="verify-btn close"
          @click="validateChanges"
        >
          {{ "Cancelar canvis" }}
        </v-btn>

        <v-btn
          small
          class="verify-btn validate"
          color="primary"
          @click="applyChanges"
        >
          {{ $t('verification.validate') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'VerificationDialog',
  props: {
    value: { type: Boolean, required: true },
    selectedItem: { type: Object, required: false, default: () => ({ errors: [] }) },
    selectedItemType: { type: String, required: false }
  },
  computed: {
    internalValue: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  },
  methods: {
    closeDialog () {
      this.internalValue = false
    },
    validateChanges () {
      const data = {
        item: this.selectedItem,
        itemType: this.selectedItemType
      }
      this.$emit('validate', data)
      this.internalValue = false
    },
    applyChanges () {
      const data = {
        item: this.selectedItem,
        itemType: this.selectedItemType
      }
      this.$emit('apply', data)
      this.internalValue = false
    }
  }
}
</script>

<style lang="scss" scoped>
.verification-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.error-item {
  background: #fdf2f2;
  border: 1px solid #f5b5b5;
  border-radius: 8px;
  padding: 10px 12px;

  .field-name {
    font-weight: 600;
    color: #c62828;
    margin-bottom: 4px;
  }

  .field-values {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .value {
      font-size: 14px;

      .label {
        font-weight: 500;
        margin-right: 4px;
      }

      &.original {
        color: #555;
      }

      &.corrected {
        color: #2e7d32;
      }
    }
  }
}

.verify-btn {
  min-width: 90px;
  height: 32px;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  border-radius: 6px;
  letter-spacing: normal;
  padding: 0 12px;

  &.close {
    color: #000 !important;
    border: 1px solid rgba(0, 0, 0, 0.3) !important;
    background-color: #fff !important;
  }

  &.validate {
    background-color: #1976d2 !important;
    color: #fff !important;
  }
}
</style>
